export const sortingOptions = [
  {
    label: "students.firstNameAZ",
    value: JSON.stringify({
      order: "asc",
      orderBy: "first_name",
    }),
  },
  {
    label: "students.firstNameZA",
    value: JSON.stringify({
      order: "desc",
      orderBy: "first_name",
    }),
  },
  {
    label: "students.lastNameAZ",
    value: JSON.stringify({
      order: "asc",
      orderBy: "last_name",
    }),
  },
  {
    label: "students.lastNameZA",
    value: JSON.stringify({
      order: "desc",
      orderBy: "last_name",
    }),
  },
]

export const sortingTextMap = {
  first_name: "students.firstName",
  last_name: "students.lastName",
}

export const STUDENTS_PAGE_SIZE = 20

export type Sort = "first_name" | "last_name"
export type SortingType = "asc" | "desc"
